import { getApolloClient } from '../lib/getApolloClient';
import {
  ADD_FAVOURITE_USER,
  GET_FAVOURITE_USERS,
  REMOVE_FAVOURITE_USER,
} from './favourite.gql';
import { FavouriteUser } from '../generated/gql-types';

const getFavouriteUsers = async (
  clientId: string,
): Promise<FavouriteUser[]> => {
  try {
    const { data } = await getApolloClient().query({
      query: GET_FAVOURITE_USERS,
      variables: { clientId },
    });
    return data.getFavouriteUsers;
  } catch (error) {
    console.error('Error getting favourite users:', error);
    throw error;
  }
};

const addFavouriteUser = async (
  clientId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const { data } = await getApolloClient().mutate({
      mutation: ADD_FAVOURITE_USER,
      variables: { clientId, userId },
    });
    return data.addFavouriteUser;
  } catch (error) {
    console.error('Error adding favourite user:', error);
    throw error;
  }
};

const removeFavouriteUser = async (
  clientId: string,
  userId: string,
): Promise<boolean> => {
  try {
    const { data } = await getApolloClient().mutate({
      mutation: REMOVE_FAVOURITE_USER,
      variables: { clientId, userId },
    });
    return data.removeFavouriteUser;
  } catch (error) {
    console.error('Error removing favourite user:', error);
    throw error;
  }
};

export const favouriteActions = {
  getFavouriteUsers,
  addFavouriteUser,
  removeFavouriteUser,
};
